@if (inputFieldConfigs.length > 0) {
<form [formGroup]="beneficiaryForm">
  <div
    formGroupName="beneficiaryAddress"
    class="finxForm pointer-events-none"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
  >
    <ng-container *ngFor="let field of inputFieldConfigs">
      @if (field.name === 'country') {
      <finxone-select-dropdown
        [label]="field.label"
        [formControlName]="field.name"
        [options]="countryList"
        [searchEnabled]="true"
        [optionLabelKey]="'title'"
        [optionValueKey]="'key'"
        [selectedOption]="beneficiaryForm.get('beneficiaryAddress')?.get(field.name)?.value"
        [formControlInvalid]="
          !!(
            beneficiaryForm.get('beneficiaryAddress')?.get(field.name)?.invalid &&
            beneficiaryForm.get('beneficiaryAddress')?.get(field.name)?.touched
          )
        "
        [validationConfig]="beneficiaryFormService.getValidationConfig(field.validation)"
        [customSelectedOptionTemplate]="customCountrySelectedOption"
      ></finxone-select-dropdown>
      } @else if (field.name === 'stateProvinceRegion' && countryHasStates()) {
      <finxone-web-frontend-state-dropdown
        [label]="field.label"
        [countryCode]="this.beneficiaryForm.get('beneficiaryAddress')?.get('country')?.value"
        [selectedStateOption]="beneficiaryForm.get('beneficiaryAddress')?.get(field.name)?.value"
        [parentFormControlName]="field.name"
        [parentFormGroup]="beneficiaryAddressFormGroup"
      ></finxone-web-frontend-state-dropdown>
      } @else {
      <finxone-input
        [type]="field.type"
        [label]="field.label"
        [formControlName]="field.name"
        [value]="beneficiaryForm.get('beneficiaryAddress')?.get(field.name)?.value"
        [formControlInvalid]="
          !!(
            beneficiaryForm.get('beneficiaryAddress')?.get(field.name)?.invalid &&
            beneficiaryForm.get('beneficiaryAddress')?.get(field.name)?.touched
          )
        "
        [validationConfig]="beneficiaryFormService.getValidationConfig(field.validation)"
      ></finxone-input>
      }
    </ng-container>
  </div>
</form>
}

<!-- Template for selected country: flag + title -->
<ng-template #customCountrySelectedOption>
  <span class="d-inline-flex gap-2">
    <ng-container
      *ngTemplateOutlet="
        flagTemplate;
        context: {
          $implicit: findCountryByKey(beneficiaryForm.get('beneficiaryAddress')?.get('country')?.value)
            ?.currencyFlag
        }
      "
    ></ng-container>
    <span>{{
      findCountryByKey(beneficiaryForm.get('beneficiaryAddress')?.get('country')?.value)?.title ||
        'Select Country'
    }}</span>
  </span>
</ng-template>

<!-- Reusable flag rendering template (used across options and selected items) -->
<ng-template #flagTemplate let-flagHtml>
  @if (widgetProperties?.['showCurrencyFlags']) {
  <span class="d-contents" [innerHTML]="flagHtml | safeHtml"></span>
  }
</ng-template>
